export function initCounter(elementId, options = {}) {
    const counterElement = document.getElementById(elementId);
    if (!counterElement) return;

    const baseValue = 8002750;
    const startDate = new Date('2025-01-01T00:00:00Z');
    const minutesPerRemoval = 1/3; // 3 removals per minute
    let animationStarted = false;
    let intervalId = null;
    
    function calculateCurrentTotal() {
        const now = new Date();
        const minutesSinceStart = Math.max(0, (now - startDate) / (1000 * 60));
        return Math.floor(baseValue + (minutesSinceStart / minutesPerRemoval));
    }

    function startCounter() {
        if (animationStarted) return;
        animationStarted = true;

        const startValue = 1;
        const endValue = calculateCurrentTotal();
        const duration = 4500;
        const startTime = performance.now();

        function updateCounter(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            
            if (progress < 1) {
                const easeProgress = 1 - Math.pow(1 - progress, 4);
                const currentValue = Math.floor(startValue + ((endValue - startValue) * easeProgress));
                const formattedValue = options.noPlus 
                    ? currentValue.toLocaleString('en-US').replace(/,/g, ',')
                    : currentValue.toLocaleString('en-US').replace(/,/g, ',') + '+';
                counterElement.textContent = formattedValue;
                requestAnimationFrame(updateCounter);
            } else {
                const formattedValue = options.noPlus 
                    ? endValue.toLocaleString('en-US').replace(/,/g, ',')
                    : endValue.toLocaleString('en-US').replace(/,/g, ',') + '+';
                counterElement.textContent = formattedValue;
                
                startContinuousCounter();
            }
        }

        requestAnimationFrame(updateCounter);
    }

    function startContinuousCounter() {
        intervalId = setInterval(() => {
            const currentTotal = calculateCurrentTotal();
            const formattedValue = options.noPlus 
                ? currentTotal.toLocaleString('en-US').replace(/,/g, ',')
                : currentTotal.toLocaleString('en-US').replace(/,/g, ',') + '+';
            counterElement.textContent = formattedValue;
        }, 1000);
    }

    // Create intersection observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                startCounter();
                observer.disconnect();
            }
        });
    }, {
        threshold: 0.1
    });

    // Start observing the counter element
    observer.observe(counterElement);

    // Return cleanup function
    return () => {
        if (intervalId) clearInterval(intervalId);
        observer.disconnect();
    };
} 